<div class="tree-node-content" [style.padding-left]="node.level * 20 + 'px'">
  <button *ngIf="!node.leaf" type="button" class="tree-node-toggle-button" (click)="toggleExpanded()" tabindex="-1">
    <ng-container *ngIf="!node.loading">
      <i *ngIf="!node.expanded" class="fa-solid fa-chevron-right tree-node-toggle-icon"></i>
      <i *ngIf="node.expanded" class="fa-solid fa-chevron-down tree-node-toggle-icon"></i>
    </ng-container>
    <ng-container *ngIf="node.loading">
      <i class="fa-solid fa-spinner fa-spin tree-node-toggle-icon"></i>
    </ng-container>
  </button>
  <span *ngIf="node.leaf" class="tree-node-toggle-button">
    <!-- Use invisible icon for leaf nodes to maintain alignment -->
    <i class="fa-solid fa-chevron-right tree-node-toggle-icon" style="visibility: hidden"></i>
  </span>

  <div class="checkbox-container" [class.pointer-events-none]="readonly" [class.opacity-50]="readonly">
    <input
      tooltipStyleClass="arp-tooltip"
      [id]="node.key"
      [pTooltip]="node.shouldDisplayTooltip ? tooltipContent : null"
      tooltipPosition="right"
      [autoHide]="false"
      type="checkbox"
      class="arpio-checkbox"
      [ngClass]="{ 'weak-dependency': node.isWeakDependency, suppressed: node.isWeakDependency && !node.checked }"
      (input)="onSelectionChange($event)"
      [indeterminate]="node.partialSelected"
      [disabled]="!node.selectable && node.checked"
      [checked]="node.checked && !node.isExcluded"
      [hideDelay]="200"
      tooltipEvent="hover"
    />
    <i *ngIf="node.isExcluded" class="fa-utility fa-semibold fa-xmark exclusion-overlay" aria-hidden="true"></i>
  </div>
  <div class="tree-node-label" [innerHTML]="node.label"></div>

  <ng-template #tooltipContent>
    <div class="tooltip-container" (mouseenter)="keepTooltipVisible()" (mouseleave)="hideTooltipDelayed()">
      <div *ngFor="let section of node.tooltipData?.sections" class="tooltip-section">
        <!-- Exclusion section -->
        <div *ngIf="section.type === 'exclusion'" [innerHTML]="section.text"></div>

        <!-- Weak dependency section -->
        <div *ngIf="section.type === 'weakDependency'" [innerHTML]="section.text"></div>

        <!-- Tags or type section -->
        <div *ngIf="section.type === 'tags' || section.type === 'resourceType'" [innerHTML]="section.text"></div>

        <!-- Dependees section with precise clipboard placement -->
        <div *ngIf="section.type === 'dependees'" class="dependees-section">
          <div class="dependees-header">
            {{ section.text }}
          </div>

          <div class="flex-row-start">
            <div>
              <i
                class="fa-utility fa-semibold fa-copy clipboard-icon"
                (click)="copySpecificArns(section.allDependeeArns)"
                title="Copy all resource ARNs"
              >
              </i>
            </div>
            <div class="dependee-list">
              <div
                *ngFor="let dependee of section.dependeeResources"
                class="dependee-item"
                [innerHTML]="dependee.displayText"
              ></div>
              <div *ngIf="section.moreCount > 0" class="more-resources">...{{ section.moreCount }} more resources</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fallback for nodes without structured data -->
      <span *ngIf="!node.tooltipData?.sections?.length" [innerHTML]="node.tooltip"></span>
    </div>
  </ng-template>
</div>
